module.exports = __webpack_public_path__ + "img/capa_46.42bc3ef0.jpg";